import { createContext } from 'react';

export const AOIWizzardContext = createContext({});